'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'icons';
var width = 512;
var height = 512;
var aliases = ["heart-music-camera-bolt"];
var unicode = 'f86d';
var svgPathData = 'M142 20.1c11.5-11.1 26.5-20.1 46.9-20.1 37 0 67 30 67 67 0 34.3-18.7 62.1-42 86.1-23.2 23.9-50.8 43.7-68.3 55.3-10.8 7.1-24.5 7.1-35.3 0-17.6-11.6-45.1-31.4-68.3-55.3-23.3-24-42-51.8-42-86.1 0-37 30-67 67-67 20.5 0 35.5 9 46.9 20.1 5 4.9 9.7 10.5 14 16.1 4.3-5.6 9-11.3 14-16.1zM67 32c-19.4 0-35 15.7-35 35 0 25.6 15.7 46 33 63.8 20.9 21.5 46.2 39.8 63 50.8 16.7-11 42.3-29.3 63.1-50.8 17.3-17.8 33-38.2 33-63.8 0-19.4-15.7-35-35-35-9.8 0-17.3 3.9-24.7 11.1-6.7 6.5-12.3 14.2-18.6 23.3-4.4 6.3-9 12.9-17.6 12.9s-13.2-6.6-17.6-12.9C104 57.3 98.4 49.6 91.7 43.1 84.3 35.9 76.9 32 67 32zM473.7 .6C493.5-3.3 512 11.8 512 32l0 148c0 28.4-28.3 52-64 52s-64-23.6-64-52 28.3-52 64-52c11.7 0 22.6 2.5 32 6.9L480 32 352 57.6 352 220c0 28.4-28.3 52-64 52s-64-23.6-64-52 28.3-52 64-52c11.7 0 22.6 2.5 32 6.9l0-117.3c0-15.3 10.8-28.4 25.7-31.4L473.7 .6zM320 220c0-5.5-8.2-20-32-20s-32 14.5-32 20 8.2 20 32 20 32-14.5 32-20zm160-40c0-5.5-8.2-20-32-20s-32 14.5-32 20 8.2 20 32 20 32-14.5 32-20zM86.5 286.2c5.9-8.9 15.9-14.2 26.6-14.2l61.7 0c10.7 0 20.7 5.3 26.6 14.2l11.8 17.8 26.7 0c26.5 0 48 21.5 48 48l0 112c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 352c0-26.5 21.5-48 48-48l26.7 0 11.8-17.8zM174.9 304l-61.7 0-16.6 24.9c-3 4.5-8 7.1-13.3 7.1L48 336c-8.8 0-16 7.2-16 16l0 112c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-112c0-8.8-7.2-16-16-16l-35.2 0c-5.3 0-10.3-2.7-13.3-7.1L174.9 304zM128 400a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 48a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM475.7 277.1c6 6.5 5.6 16.6-.8 22.6L392.7 376 480 376c6.6 0 12.5 4 14.9 10.2s.8 13.1-4 17.6l-112 104c-6.5 6-16.6 5.6-22.6-.8s-5.6-16.6 .8-22.6l82.1-76.3-87.3 0c-6.6 0-12.5-4-14.9-10.2s-.8-13.1 4-17.6l112-104c6.5-6 16.6-5.6 22.6 .8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIcons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;